import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Courses from './components/Courses';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 66; // navbar height
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div style={{ background: '#080d1a', minHeight: '100vh' }}>
      <Navbar scrollTo={scrollTo} />

      <section id="home">
        <Home scrollTo={scrollTo} />
      </section>

      <section id="courses">
        <Courses scrollTo={scrollTo} />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="testimonials">
        <Testimonials />
      </section>

      <section id="contact">
        <Contact />
      </section>

      <Footer scrollTo={scrollTo} />
    </div>
  );
}

export default App;
